import { render, staticRenderFns } from "./review-section-title.vue?vue&type=template&id=74a53590&scoped=true&lang=pug"
import script from "./review-section-title.vue?vue&type=script&lang=ts"
export * from "./review-section-title.vue?vue&type=script&lang=ts"
import style0 from "./review-section-title.vue?vue&type=style&index=0&id=74a53590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a53590",
  null
  
)

export default component.exports